define('views/IntroView',[
    'backbone',
    'lodash',
    'text!templates/intro.html',
    'app'
], function (Backbone, _, introTmpl, App) {

    "use strict";

    return Backbone.View.extend({

        tagName: 'article',

        id: 'intro',

        render: function () {
            this.$el.html(this.template(App));
        },

        template: _.template(introTmpl)

    });

});
